(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascent-hero"]) return;
  try {
    
  (function () {
    if (window.__tpAscent) {
      window.__tpAscent.destroy();
    }

    function init() {
      var root = document.querySelector('[data-ascent-root]');
      var canvas = document.querySelector('[data-ascent-canvas]');
      if (!root || !canvas) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var finePointer = window.matchMedia('(pointer: fine)').matches;

      var cursorEl = document.querySelector('[data-ascent-cursor]');
      var hudL = document.querySelector('[data-ascent-hud-l]');
      var hudR = document.querySelector('[data-ascent-hud-r]');
      var altEl = document.querySelector('[data-ascent-alt]');
      var tempEl = document.querySelector('[data-ascent-temp]');
      var dotEl = document.querySelector('[data-ascent-dot]');
      var titleEl = document.querySelector('[data-ascent-title]');
      var skipBtn = document.querySelector('[data-ascent-skip]');
      var footerEl = document.querySelector('[data-ascent-footer]');
      var beginEl = document.querySelector('[data-ascent-begin]');
      var waypointEls = Array.prototype.slice.call(document.querySelectorAll('[data-ascent-waypoint]'));
      var revealEls = Array.prototype.slice.call(document.querySelectorAll('[data-ascent-reveal]'));

      var altStart = parseFloat(root.dataset.altStart || '60');
      var altEnd = parseFloat(root.dataset.altEnd || '1800');
      var altClimbP = parseFloat(root.dataset.altClimb || '0.6');
      var tempStart = parseFloat(root.dataset.tempStart || '24');
      var tempEnd = parseFloat(root.dataset.tempEnd || '8');
      var starDensity = parseInt(root.dataset.starDensity || '140', 10);
      var mistIntensity = parseFloat(root.dataset.mistIntensity || '1');
      var goldSunrise = root.dataset.goldSunrise === 'true';
      var scrollJourney = root.dataset.scrollJourney === 'true';

      var ctx = canvas.getContext('2d');
      var dpr = 1;
      var ridges = [];
      var stars = [];
      var mist = [];
      var scrollP = 0;
      var mx = 0;
      var mnx = 0;
      var mny = 0;
      var rawX = -50;
      var rawY = -50;
      var curX = -50;
      var curY = -50;
      var raf = null;
      var running = true;

      function mulberry(a) {
        return function () {
          a |= 0;
          a = (a + 0x6d2b79f5) | 0;
          var t = Math.imul(a ^ (a >>> 15), 1 | a);
          t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
          return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
      }

      function setupCanvas() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = window.innerWidth * dpr;
        canvas.height = window.innerHeight * dpr;
        var W = window.innerWidth;
        var H = window.innerHeight;
        var steps = [260, 220, 180, 150, 120];
        var amps = [0.045, 0.06, 0.08, 0.1, 0.125];
        ridges = [];
        for (var i = 0; i < 5; i++) {
          var rng = mulberry(i * 37 + 11);
          var n = Math.ceil(W / steps[i]) + 2;
          var pts = [];
          for (var j = 0; j < n; j++) {
            var y = rng() * 2 - 1;
            if (rng() < 0.2) y *= 1.9;
            pts.push(Math.max(-1.15, Math.min(1.15, y)));
          }
          if (i < 2) {
            for (var k = 1; k < n - 1; k++) pts[k] = (pts[k - 1] + pts[k] + pts[k + 1]) / 3;
          }
          ridges.push({ pts: pts, step: steps[i], amp: amps[i] });
        }
        buildStars();
        var rm = mulberry(99);
        mist = [];
        for (var m = 0; m < 24; m++) {
          mist.push({
            x: rm() * W,
            yf: 0.55 + rm() * 0.4,
            w: 200 + rm() * 320,
            h: 40 + rm() * 60,
            s: 0.12 + rm() * 0.3,
          });
        }
      }

      function buildStars() {
        var rs = mulberry(5);
        stars = [];
        for (var i = 0; i < starDensity; i++) {
          stars.push({ x: rs(), y: rs() * 0.55, r: 0.5 + rs() * 0.9, ph: rs() * 6.28 });
        }
      }

      function lerpC(c1, c2, t) {
        return [
          Math.round(c1[0] + (c2[0] - c1[0]) * t),
          Math.round(c1[1] + (c2[1] - c1[1]) * t),
          Math.round(c1[2] + (c2[2] - c1[2]) * t),
        ];
      }

      function drawFrame(t) {
        var W = window.innerWidth;
        var H = window.innerHeight;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        var pSun = goldSunrise ? Math.min(1, Math.max(0, (scrollP - 0.74) / 0.26)) : 0;
        var eS = pSun * pSun * (3 - 2 * pSun);
        var top = lerpC(lerpC([11, 11, 11], [4, 6, 12], scrollP), [16, 12, 7], eS * 0.5);
        var bot = lerpC(lerpC([17, 16, 12], [11, 11, 11], scrollP), [36, 26, 10], eS * 0.6);
        var g = ctx.createLinearGradient(0, 0, 0, H);
        g.addColorStop(0, 'rgb(' + top + ')');
        g.addColorStop(1, 'rgb(' + bot + ')');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);

        var sA = scrollJourney
          ? Math.min(1, Math.max(0, (scrollP - 0.3) / 0.3)) * (1 - eS * 0.75)
          : 0.8;
        if (sA > 0.01) {
          for (var s = 0; s < stars.length; s++) {
            var st = stars[s];
            var a = sA * (0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * 0.0012 + st.ph)));
            ctx.globalAlpha = a * 0.8;
            ctx.fillStyle = '#EEEDE9';
            ctx.beginPath();
            ctx.arc(st.x * W, st.y * H, st.r, 0, 6.283);
            ctx.fill();
          }
        }
        ctx.globalAlpha = 1;

        if (eS > 0.01) {
          var cy = H * (1.25 - 0.83 * eS);
          var cx = W * 0.5 + mx * 14;
          var r = H * 0.3;
          var gl = ctx.createRadialGradient(cx, cy, r * 0.15, cx, cy, r * 2.4);
          gl.addColorStop(0, 'rgba(230,198,81,' + 0.5 * eS + ')');
          gl.addColorStop(1, 'rgba(230,198,81,0)');
          ctx.fillStyle = gl;
          ctx.fillRect(0, 0, W, H);
          ctx.globalAlpha = 0.95 * eS;
          ctx.fillStyle = '#E6C651';
          ctx.beginPath();
          ctx.arc(cx, cy, r, 0, 6.283);
          ctx.fill();
          ctx.globalAlpha = 1;
        }

        var conf = [
          { b: 0.5, s: 0.06, col: '#171512' },
          { b: 0.58, s: 0.13, col: '#131110' },
          { b: 0.66, s: 0.24, col: '#0f0e0c' },
          { b: 0.76, s: 0.4, col: '#0b0a09' },
          { b: 0.88, s: 0.62, col: '#070606' },
        ];
        for (var i = 0; i < ridges.length; i++) {
          var rg = ridges[i];
          var cf = conf[i];
          var y0 = H * (cf.b + scrollP * cf.s);
          var dx = mx * (10 + i * 13);
          ctx.beginPath();
          ctx.moveTo(-60 + dx, y0 + rg.pts[0] * H * rg.amp);
          for (var p = 1; p < rg.pts.length; p++) ctx.lineTo(-60 + dx + p * rg.step, y0 + rg.pts[p] * H * rg.amp);
          ctx.lineTo(W + 80, H + 80);
          ctx.lineTo(-80, H + 80);
          ctx.closePath();
          ctx.fillStyle = cf.col;
          ctx.fill();
          if (i >= 3) {
            ctx.strokeStyle = 'rgba(230,198,81,' + (0.09 + 0.08 * (i - 3)) + ')';
            ctx.lineWidth = 1.2;
            ctx.stroke();
          }
        }

        if (mistIntensity > 0.01) {
          for (var mi = 0; mi < mist.length; mi++) {
            var mp = mist[mi];
            mp.x += mp.s;
            if (mp.x - mp.w > W) mp.x = -mp.w;
            ctx.globalAlpha = 0.035 * mistIntensity * (1 - scrollP * 0.75);
            ctx.fillStyle = '#EEEDE9';
            ctx.beginPath();
            ctx.ellipse(mp.x, mp.yf * H, mp.w, mp.h, 0, 0, 6.283);
            ctx.fill();
          }
          ctx.globalAlpha = 1;
        }
      }

      function updateHud() {
        var climbP = Math.min(scrollP, altClimbP) / altClimbP;
        var alt = altStart + climbP * (altEnd - altStart);
        if (altEl) altEl.textContent = Math.round(alt).toLocaleString('en-US');
        if (tempEl) tempEl.textContent = Math.round(tempStart + (tempEnd - tempStart) * scrollP);
        if (dotEl) dotEl.style.transform = 'translate(-50%,' + (scrollP * 200 - 3.5) + 'px)';

        var nearFooter = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight - 40 : false;
        var hudOn = scrollY > 40 && !nearFooter ? 1 : 0;
        if (hudL) hudL.classList.toggle('is-visible', !!hudOn);
        if (hudR) hudR.classList.toggle('is-visible', !!hudOn);
        if (skipBtn) skipBtn.classList.toggle('is-hidden', nearFooter);
        if (beginEl) beginEl.classList.toggle('is-hidden', scrollY > 40);

        waypointEls.forEach(function (el) {
          var threshold = parseFloat(el.dataset.threshold || '0');
          el.classList.toggle('is-active', scrollP >= threshold - 0.02);
        });
      }

      function tick(t) {
        var target = Math.min(1, Math.max(0, window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight)));
        scrollP += (target - scrollP) * (reduceMotion ? 1 : 0.08);
        mx += (mnx - mx) * 0.06;
        if (finePointer && !reduceMotion) {
          curX += (rawX - curX) * 0.2;
          curY += (rawY - curY) * 0.2;
          if (cursorEl) cursorEl.style.transform = 'translate3d(' + (curX - 4.5) + 'px,' + (curY - 4.5) + 'px,0)';
          if (titleEl) titleEl.style.transform = 'translate(' + (mx * -12) + 'px,' + (mny * -7) + 'px)';
        }
        drawFrame(t);
        updateHud();
        if (running && !reduceMotion) raf = requestAnimationFrame(tick);
      }

      function onMove(e) {
        mnx = (e.clientX / window.innerWidth - 0.5) * 2;
        mny = (e.clientY / window.innerHeight - 0.5) * 2;
        rawX = e.clientX;
        rawY = e.clientY;
      }

      function onVisibility() {
        if (document.hidden) {
          running = false;
          if (raf) cancelAnimationFrame(raf);
        } else if (!reduceMotion) {
          running = true;
          raf = requestAnimationFrame(tick);
        }
      }

      var io = null;
      if ('IntersectionObserver' in window && !reduceMotion) {
        io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.2 }
        );
        revealEls.forEach(function (el) {
          el.classList.add('ascent-reveal-armed');
          io.observe(el);
        });
      } else {
        revealEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      }

      setupCanvas();
      window.addEventListener('resize', setupCanvas);

      if (finePointer && !reduceMotion) {
        window.addEventListener('mousemove', onMove);
        document.body.classList.add('has-hidden-cursor');
        if (cursorEl) cursorEl.classList.add('is-active');
      }

      document.addEventListener('visibilitychange', onVisibility);

      if (skipBtn) {
        skipBtn.addEventListener('click', function () {
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        });
      }

      if (reduceMotion) {
        drawFrame(0);
        updateHud();
      } else {
        raf = requestAnimationFrame(tick);
      }

      window.__tpAscent = {
        destroy: function () {
          running = false;
          if (raf) cancelAnimationFrame(raf);
          window.removeEventListener('resize', setupCanvas);
          window.removeEventListener('mousemove', onMove);
          document.removeEventListener('visibilitychange', onVisibility);
          if (io) io.disconnect();
        },
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-quantity-decrease], [data-cart-quantity-increase]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.cart-page__item-quantity');
      const input = wrapper.querySelector('[data-cart-quantity-input]');
      const delta = button.hasAttribute('data-cart-quantity-decrease') ? -1 : 1;
      input.value = Math.max(0, Number(input.value) + delta);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-form-submit]').forEach((button) => {
    const form = button.closest('form');
    if (!form) return;

    const variantsScript = form.querySelector('[data-product-form-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const optionInputs = form.querySelectorAll('[data-product-form-option]');
    const variantIdInput = form.querySelector('[data-product-form-variant-id]');
    const submitText = form.querySelector('[data-product-form-submit-text]');
    const quantityInput = form.querySelector('[data-quantity-input]');

    function getSelectedOptions() {
      const options = [];
      optionInputs.forEach((input) => {
        const index = Number(input.dataset.productFormOption);
        if (input.type === 'radio' && !input.checked) return;
        options[index] = input.value;
      });
      return options;
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const match = variants.find((variant) => {
        return variant.options.every((value, index) => value === selected[index]);
      });

      if (!match) return;

      variantIdInput.value = match.id;
      button.disabled = !match.available;

      if (submitText) {
        submitText.textContent = match.available
          ? submitText.dataset.addLabel + ' — ' + formatMoney(match.price)
          : submitText.dataset.soldOutLabel;
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    }

    optionInputs.forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    form.querySelectorAll('[data-quantity-decrease]').forEach((el) => {
      el.addEventListener('click', () => {
        quantityInput.value = Math.max(1, Number(quantityInput.value) - 1);
      });
    });

    form.querySelectorAll('[data-quantity-increase]').forEach((el) => {
      el.addEventListener('click', () => {
        quantityInput.value = Number(quantityInput.value) + 1;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
